
import axios from "axios";
import { getConfig } from "../../../ApiHelpers/ApiDefaultConfig";

const postAdminAuth = async ({ ownerName, password }: { ownerName: string, password: string }) => {
    let config = getConfig();
    let payload = {
        ownerName,
        password,
    }

    try {
        const response = await axios.post(`/authAdminUser`, payload, config);
        return response;
    } catch (error) {
        return error
    }
};

export { postAdminAuth }